import WrapCards from "@/components/cardsWrap";
import { NAVIGATION_CARDS_CONSTANTS } from "./navigationCardsConstants";

const NavigationCards = () => {
  return <WrapCards list={NAVIGATION_CARDS_CONSTANTS.list} />;
};

export default NavigationCards;
